import firebase from 'firebase'
import 'firebase/firestore'

const firebaseConfig = require('../../.runtimeconfig')

const debug = firebaseConfig.project.debug
// console.log("Debug is:", debug)

const projectURL = firebaseConfig.project.url

// firebase init goes here
const config = {
  apiKey: firebaseConfig.client.api_key,
  authDomain: firebaseConfig.client.auth_domain,
  databaseURL: firebaseConfig.client.database_url,
  projectId: firebaseConfig.client.project_id,
  storageBucket: firebaseConfig.client.storage_bucket,
  messagingSenderId: firebaseConfig.client.messaging_sender_id
}

firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser
const fireStorage = firebase.storage()
const fireStorageRef = fireStorage.ref();

auth.useDeviceLanguage()

//Comment this line out to enable recaptcha
if(debug == 'false') auth.settings.appVerificationDisabledForTesting = false
else auth.settings.appVerificationDisabledForTesting = true

auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)

// firebase collections
// const usersCollfirfirection = db.collection('users')
// const postsCollection = db.collection('posts')
// const commentsCollection = db.collection('comments')
// const likesCollection = db.collection('likes')

export {
    debug,
    projectURL,
    db,
    auth,
    firebase,
    currentUser,
    fireStorageRef
    // usersCollection,
    // postsCollection,
    // commentsCollection,
    // likesCollection
}
